(function ( window, angular, undefined ) {
